// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__ftGjX","emails":"CreateEditClinics_emails__2ouDl","emailTagLabel":"CreateEditClinics_emailTagLabel__1VVtB"};